import React from 'react'
import { Text, Icon } from 'components/library'
import './Video.css'

class Video extends React.Component {
  state = {
    playVideo: true
  }

  handlePlay = () => {
    this.setState({ playVideo: true })
  }

  render() {
    const classNames = ['Video']

    return (
      <div className={classNames.join(' ')}>
        <div className="Video-container" style={{paddingBottom: this.props.videoHeight}}>

          {this.state.playVideo && this.props.vimeoId &&
          <div className="Video-player" >
            <iframe title="video"
                    src={`https://player.vimeo.com/video/${this.props.vimeoId}?title=0&byline=0&portrait=0`}
                    frameBorder="0" allowFullScreen={true}></iframe>
          </div>
          }
          {
            this.props.inline &&
            <div className="Video-player">
              <video loop mute autoPlay>
                <source src={this.props.src} type={"video/mp4"} />
              </video>
            </div>
          }

          {!this.state.playVideo &&
            <div className="Video-cover" style={{ backgroundImage: `url(${this.props.cover})` }} />
          }

          {!this.state.playVideo &&
            <a className="Video-trigger" onClick={this.handlePlay}>
              <span className="Video-trigger-icon"><Icon name="play" size="large" /></span>
            </a>
          }
        </div>
        {this.props.label && 
          <div className="Video-label"><Text small>{this.props.label}</Text></div>
        }
      </div>
    )
  }
}

export default Video



// WEBPACK FOOTER //
// ./src/components/library/video/Video.js